import { HSLColor } from 'react-color';
import { Or } from 'source/app/domain/Or';
import { GetColorString } from 'source/app/presentation/MainPanel/DevTools/Texturizer/ColorPicker/ColorPicker';
import { StyleClass } from 'source/app/presentation/Shared/Styles/CSS';
import { MathUtils } from 'source/app/services/Math/MathUtils';
import { DesktopImage } from '../DesktopImage/DesktopImage';
import { ETexture } from './ETexture';
import { HSLColors } from './Helpers/HSLColor';
import { ITextureInputs } from './Interfaces/ITexture';

export class Texture implements ITextureInputs {
	private backgroundProperties: React.CSSProperties = {};

	readonly image: ETexture;

	readonly backgroundColor?: HSLColor;

	constructor(inputs: ITextureInputs) {
		this.image = inputs.image;
		this.backgroundColor = inputs.backgroundColor;

		this.backgroundProperties = {
			backgroundImage: `url('/images/backgrounds/patterns/${ETexture[
				this.image
			]}.png')`,
			backgroundColor: GetColorString(
				Or(this.backgroundColor, HSLColors.black)
			)
		};
	}

	public get css(): React.CSSProperties {
		const extendedBackgroundCSS = this.GetPropertiesWithRandomOffsets();
		return extendedBackgroundCSS;
	}

	public get combinedCSS(): React.CSSProperties {
		const extendedBackgroundCSS = this.GetPropertiesWithRandomOffsets();

		var combinedCSS = {
			background: `${extendedBackgroundCSS.backgroundImage} ${extendedBackgroundCSS.backgroundColor}`
		};

		return combinedCSS;
	}

	public AsDesktopImage(): DesktopImage {
		const imageName = ETexture[this.image];
		const backgroundColor = this.backgroundProperties.backgroundColor;

		return new DesktopImage(
			StyleClass(`${imageName}_${backgroundColor}`, {
				...this.css,
				height: '100%'
			})
		);
	}

	private GetPropertiesWithRandomOffsets(): React.CSSProperties {
		return {
			...this.backgroundProperties,
			backgroundPositionX: `${MathUtils.RandomNumberBetween(0, 100)}px`,
			backgroundPositionY: `${MathUtils.RandomNumberBetween(0, 100)}px`
		};
	}
}
